import React, {Fragment} from 'react';
import type {Media} from 'services/media/types';
import {useLocalization} from 'localization';
import {ColorPalette} from 'theme';
import {useOpenMultipleMedia} from 'services/media';
import {Card, Spacer, ToolBar} from 'components';
import {useTextValue} from 'schema/preview/hooks';
import {FileCard} from './FileCard';
import {ManifestationPanelContainer} from './ManifestationPanelContainer';

type Props = {
  media: Media[];
  manifestationId: string;
  onClose: () => void;
  trykkunderlagReserved?: boolean;
};

export const FilesPanel: React.FC<Props> = ({
  media,
  manifestationId,
  onClose,
  trykkunderlagReserved,
}) => {
  const TextValue = useTextValue();
  const {t} = useLocalization();

  const {previewAll} = useOpenMultipleMedia(media);

  const OpenAllComponent = (
    <ToolBar.ControlledIconTool
      icon="Preview"
      size="small"
      onClick={previewAll}
      isCalling={false}
    />
  );

  return (
    <ManifestationPanelContainer
      title={t('page.metadata.manifestation.tools.files')}
      icon={'Files'}
      onClose={onClose}
      extraButtons={[OpenAllComponent]}>
      {trykkunderlagReserved ? (
        <Card colorx={ColorPalette.primary.white}>
          <TextValue>{t('error.files.reserved')}</TextValue>
        </Card>
      ) : null}

      {Array.isArray(media) && media.length > 0 ? (
        media.map((f, idx, data) => (
          <Fragment key={f.id}>
            <FileCard file={f} manifestationId={manifestationId} />
            {idx + 1 < data.length ? <Spacer size={1} /> : null}
          </Fragment>
        ))
      ) : (
        <Card colorx={ColorPalette.primary.white}>
          <TextValue>{t('error.files.empty')}</TextValue>
        </Card>
      )}
    </ManifestationPanelContainer>
  );
};
